module.exports = __webpack_public_path__ + "static/media/Portrait-10068_original.cc75b028.jpg";